export default {
  header: {
    house: 'Casa',
    activities: 'Attività',
    beaches: 'Spiagge',
    history: 'Storia',
    contact: 'Contatto',
    phone: '+30 6983446269'
  },
  hero: {
    title: 'Create la vostra fuga rilassante a Creta',
    bookNow: 'Prenota ora',
    phone: '+30 6983446269',
    airbnb: 'Airbnb',
    booking: 'Booking',
    yourRentals: 'YourRentals'
  },
  house: {
    title: 'Azure Loft',
    description: 'Scopri Azure Loft, un affascinante appartamento boho nel cuore di Creta, progettato per il massimo relax e comfort. Con una vista mare mozzafiato, un\'estetica boho calda e tutti i comfort moderni, è la scelta ideale per coppie, famiglie o amici che cercano un\'esperienza di soggiorno unica.',
    features: [
      'Spazi',
      '1 camera da letto in tradizionale soppalco in legno con comodo letto matrimoniale',
      'Sala da pranzo con divano letto, adatta per un ospite in più',
      'Soggiorno confortevole con TV e decorazioni luminose',
      'Balcone con tavolo e sedie, perfetto per godersi la vista mare unica',
      'Cucina & Servizi',
      'Cucina completamente attrezzata con frigorifero, forno, piano cottura, macchina da caffè e tutte le stoviglie necessarie',
      'Bagno con doccia, sanitari moderni e acqua calda 24/7',
      'Comfort & Extra',
      'Aria condizionata',
      'Lavatrice e ferro da stiro',
      'Biancheria bianca pulita (lenzuola, asciugamani, cuscini)',
      'TV a schermo piatto',
      'Parcheggio facile vicino alla struttura'
    ],
    bookNow: 'Prenota ora',
    rooms: {
      bedroom: 'Camera da letto',
      livingRoom: 'Soggiorno',
      bedroom2: 'Camera da letto 2',
      kitchen: 'Cucina',
      veranda: 'Veranda'
    },
    viewPhotos: 'Vedi foto',
    closeGallery: 'Chiudi'
  },
  reasons: {
    title: 'Le 5 migliori ragioni per soggiornare',
    reason1: {
      title: '1. Viste mozzafiato',
      description: 'Dal balcone di Azure Loft assisterete a una scena uscita da un dipinto: il mare cretese infinito, il porto di Heraklion sullo sfondo e i colori del tramonto che dipingono il cielo ogni sera. Perfetto per il caffè del mattino e il vino della sera, con una sensazione unica di tranquillità.'
    },
    reason2: {
      title: '2. La città... a un respiro di distanza',
      description: 'Anche se siete in un villaggio tranquillo, il centro di Heraklion è a soli 15-20 minuti di distanza. Lì troverete tutto quello che vi serve: dai musei e attrazioni al mercato vivace, ristoranti, bar ed eventi culturali. L\'accesso è facile e ideale per gite di un giorno.'
    },
    reason3: {
      title: '3. Creta autentica',
      description: 'Rodia è uno dei villaggi tradizionali più belli di Heraklion. Costruito su una collina con vista mare e pieno di vicoli lastricati di pietra, piccoli cortili e vecchie case, offre una sensazione di autenticità che è rara. È un posto dove il tempo scorre più lentamente – e questo è il suo più grande privilegio.'
    },
    reason4: {
      title: '4. Spiagge dalle acque cristalline',
      description: 'A meno di 20 minuti di auto da Azure Loft, spiagge aspettano per ogni preferenza. Ammoudara offre organizzazione e vivacità, Ligaria è ideale per famiglie con acque pulite e calme, mentre Agia Pelagia combina bel paesaggio e buon cibo vicino al mare. Per momenti più tranquilli, preferite Made o la pittoresca Psaromoura, con acque blu cristallo e atmosfera cretese autentica.'
    },
    reason5: {
      title: '5. Per momenti che durano',
      description: 'Azure Loft è ideale per chi vuole fuggire dall\'ordinario e vivere qualcosa di più autentico, umano e pacifico. Che viaggiate con il partner, famiglia o amici, qui sentirete un vero relax e creerete ricordi che ricorderete con un sorriso.'
    }
  },
  location: {
    title: 'La nostra posizione',
    subtitle: 'Un paradiso pittoresco',
    description: 'Azure Loft si trova nell\'incantevole Rodia di Heraklion, un insediamento cretese tradizionale costruito anfiteatralmente su una collina, con viste panoramiche sul mare cretese e sulla città di Heraklion. Rodia combina ospitalità autentica con bellezza naturale unica, servendo come punto di partenza ideale per esplorare sia l\'entroterra che la costa settentrionale dell\'isola.\n\nA breve distanza potete scoprire acque cristalline, come Palaikastro, Ammoudara e il porto di Ligaria, ideali per nuotare, prendere il sole e attività acquatiche.\n\nGli appassionati di storia e cultura possono facilmente visitare il Museo Archeologico di Heraklion (18 km), le Mura Veneziane (17 km), così come il famoso Palazzo di Cnosso (21 km). Per una gita in famiglia, Cretaquarium – Thalassokosmos è a soli 33 km e offre un\'esperienza indimenticabile per giovani e meno giovani.\n\nLa posizione di Azure Loft assicura facile accesso all\'Aeroporto Internazionale di Heraklion (20 km), mentre l\'alloggio ha anche parcheggio privato gratuito, offrendo comodità per i vostri trasporti.\n\nScoprite il fascino della Creta autentica, con il mare come sfondo e la tranquillità del paesaggio semi-montuoso di Rodia.'
  },
  calendar: {
    title: 'Disponibilità Azure Loft',
    close: 'Chiudi',
    bookAirbnb: 'Prenota su Airbnb',
    bookBooking: 'Prenota su Booking',
    bookYourRentals: 'Prenota su YourRentals',
    requestQuote: 'Richiedi preventivo'
  },
  footer: {
    generalInfo: 'Informazioni generali',
    location: 'Posizione',
    getDirections: 'Ottieni indicazioni',
    contactWays: 'Modi di contatto',
    faq: 'Domande frequenti',
    usefulLinks: 'Link utili',
    carRental: 'Noleggio auto',
    busRoutes: 'Percorsi bus',
    cityGuide: 'Guida della città',
    socialMedia: 'Social media',
    newsletter: 'Newsletter',
    emailPlaceholder: 'La tua email',
    signUp: 'Iscrivimi!',
    copyright: 'Copyright © AZURE LOFT GREECE 2025',
    manual: 'Manuale della casa'
  },
  reviews: [
    {
      author: 'Gerasimos',
      date: '5 mesi fa',
      rating: 5,
      text: 'Abbiamo avuto un\'esperienza eccellente durante il nostro soggiorno nella casa in affitto! L\'alloggio era impeccabile, completamente attrezzato e molto confortevole. La sua posizione era ideale, vicino a tutto quello che ci serviva, ma allo stesso tempo abbastanza tranquilla per goderci la nostra pace. Il proprietario era estremamente amichevole e disponibile, sempre disponibile ad aiutarci con qualsiasi domanda o necessità che sorgeva. Ci ha anche dato consigli utili sulla zona, come posti per mangiare e attività. La casa aveva decorazioni moderne, letti comodi e tutto quello che ci serviva per sentirci a casa. Il Wi-Fi era veloce e affidabile, cosa che abbiamo particolarmente apprezzato. Nel complesso, un\'esperienza fantastica che raccomanderei sicuramente a chiunque cerchi un alloggio di qualità. Non vediamo l\'ora di tornare!'
    },
    {
      author: 'Ioannis Papadakis',
      date: '5 mesi fa',
      rating: 5,
      text: 'Davvero una bella casa calda con viste incredibili. Abbiamo soggiornato a Heraklion per un breve periodo dato che la nostra destinazione era a sud di Rethymno. La prima cosa che ha attirato la nostra attenzione è stata la vista quando abbiamo fatto la prenotazione ed è davvero incredibile. Inoltre la casa è molto pulita e profumava bene, cosa molto piacevole quando entri per la prima volta nella villa.'
    },
    {
      author: 'Panagiotis Chandroulidis',
      date: '1 mese fa',
      rating: 5,
      text: 'È meraviglioso con belle viste. Il proprietario è ospitale e molto gentile. Vi consiglio di sceglierlo, sono sicuro che apprezzerete il vostro soggiorno.'
    },
    {
      author: 'Vasilis',
      date: '2 marzo 2025',
      rating: 5,
      text: 'La casa era molto bella e ideale per fughe romantiche. Completamente attrezzata e potevamo cucinare😊 La vista di notte era fantastica dalla casa insieme a un bicchiere di vino era qualcos\'altro. L\'ospite ci ha inviato istruzioni dettagliate per la casa. Abbastanza amichevole. Impressione molto buona nel complesso.',
      source: 'booking'
    },
    {
      author: 'Sevi Kallergi',
      date: '23 settimane fa',
      rating: 5,
      text: 'Viste magiche e spazio confortevole. Era pulito e tutto era perfetto! Tranquillo e rilassante. Tornerò sicuramente!'
    },
    {
      author: 'alex tevre',
      date: '24 settimane fa',
      rating: 5,
      text: 'Visitando Creta frequentemente, posso onestamente dire che questo è stato uno dei migliori appartamenti in cui ho mai soggiornato! L\'incredibile...'
    },
    {
      author: 'Eirini Vrentzou',
      date: '24 settimane fa',
      rating: 5,
      text: 'Davvero meraviglioso.... Non ho parole per descrivere la bellezza..tutto era perfetto e ben curato...lo raccomando senza riserve...'
    },
    {
      author: 'Antonis Aerakis',
      date: '24 settimane fa',
      rating: 5,
      text: 'Tutto era perfetto! Spazio meraviglioso e pulito con viste incredibili!'
    },
    {
      author: 'Konstantina Orfanou',
      date: '24 settimane fa',
      rating: 5,
      text: 'Spazio molto bello e gli ospiti sono amichevoli, disponibili e pronti ad aiutare....'
    },
    {
      author: 'Penny Stathogiannopoulou',
      date: '24 settimane fa',
      rating: 5,
      text: 'Spazio meraviglioso con estetica molto bella. Impeccabile e ben curato fino all\'ultimo dettaglio! Il mio posto preferito...'
    },
    {
      author: 'MARIA IOANNA RESTIVAKI',
      date: '24 settimane fa',
      rating: 5,
      text: 'Se state cercando una fuga pacifica e pittoresca, questa casa vacanze a Rodia è una scelta eccellente!...'
    },
    {
      author: 'Maria Stavroulaki',
      date: '24 settimane fa',
      rating: 5,
      text: 'Spazio molto bello e combinato con la vista incredibile di Heraklion ha reso il nostro soggiorno indimenticabile!!'
    },
    {
      author: 'vasilis maris',
      date: '24 settimane fa',
      rating: 5,
      text: 'Vi do le mie congratulazioni per quanto sia bella e rinnovata la vostra casa. Il nostro soggiorno è stato meraviglioso e il...'
    },
    {
      author: 'Manos Papadakis',
      date: '24 settimane fa',
      rating: 5,
      text: 'Viste molto belle, l\'inquilino molto disponibile e qualsiasi problema avevo veniva risolto immediatamente lo raccomando senza riserve per le vostre vacanze sia estive che invernali 😁'
    },
    {
      author: 'Panagiotis',
      date: '25 giugno 2025',
      rating: 5,
      text: 'Il proprietario e il manager sono persone meravigliose, ospitali e gentili. Abbiamo avuto un soggiorno perfetto e una meravigliosa collaborazione. La casa era pulita e al nostro arrivo siamo stati accolti con una bella sorpresa. Ma il punto forte è il balcone, la vista è bellissima, potete vedere tutta Heraklion e l\'infinito blu del mare.',
      source: 'booking'
    },
    {
      author: 'Lise',
      date: 'Maggio 2025',
      rating: 3,
      text: 'Buona posizione per visitare la zona di Heraklion e vicino all\'aeroporto. Piccolo alloggio per 4 persone (inclusi bambini, scala a chiocciola). Alcuni miglioramenti sono necessari...',
      source: 'airbnb'
    },
    {
      author: 'Emmanouil',
      date: 'Aprile 2025',
      rating: 5,
      text: 'Posto tranquillo con belle viste. La comunicazione era eccellente.',
      source: 'airbnb'
    },
    {
      author: 'Emmanouil',
      date: 'Marzo 2025',
      rating: 5,
      text: 'La casa era molto pulita e la vista dal balcone era incredibile e avevate tutti i comfort e l\'ospite era molto amichevole e mi ha aiutato con qualsiasi problema avessi',
      source: 'airbnb'
    }
  ],
  reviewsSection: {
    subtitle: 'Cosa dicono i nostri visitatori!',
    title: 'Recensioni'
  },
  contact: {
    title: 'Contattaci',
    phone: 'TELEFONO',
    email: 'EMAIL',
    namePlaceholder: 'Inserisci il tuo nome',
    emailPlaceholder: 'Inserisci un indirizzo email valido',
    messagePlaceholder: 'Il tuo messaggio',
    submit: 'INVIA',
    sending: 'Invio...',
    success: 'Il tuo messaggio è stato inviato con successo!',
    error: 'Si è verificato un errore. Riprova.'
  },
  readMore: 'Leggi di più',
  readLess: 'Leggi di meno'
}; 